import { NavigateFunction } from "react-router-dom";
import { Dispatch } from "redux";
import { ACTION_KEY, ACTION_SELECTED_ID_KEY, PARENT_ID_KEY, endpoints } from "config";
import { setActionID, setActionKey, setTemporaryFilters } from "reducers/redirect";
import { setRedirectUrl, setRedirectUrlDestinationModule } from "reducers/listPage";

/**
 * Parameters required for project redirect (from URL)
 */
export interface ProjectRedirectParams {
  ProjectId: string;
  ProgrammeId: string;
}

/**
 * Handles redirect to a specific project in project management
 * Reuses the same pattern as SimpleProjectCard navigation
 *
 * @param params - Project and programme IDs (PascalCase from URL)
 * @param navigate - React Router navigate function
 * @param dispatch - Redux dispatch function
 */
export const handleProjectRedirect = (
  params: ProjectRedirectParams,
  navigate: NavigateFunction,
  dispatch: Dispatch
): void => {
  const { ProjectId, ProgrammeId } = params;

  // Set localStorage values (required by ProjectManagement component)
  window.localStorage.setItem(ACTION_KEY, "VIEW");
  window.localStorage.setItem(ACTION_SELECTED_ID_KEY, ProjectId);
  window.localStorage.setItem(PARENT_ID_KEY, ProgrammeId);

  // Set Redux state
  dispatch(setActionKey("VIEW"));
  dispatch(setActionID(ProjectId));
  dispatch(setTemporaryFilters(true));
  dispatch(setRedirectUrlDestinationModule("/projectmanagement"));

  // Build the redirect URL with filters to show the specific project
  const redirectUrl = `${endpoints.projectmanagement.list}?bTemporaryFilters=true&ProgrammesId=${ProgrammeId}&bClearSearch=true&filters=Projects__ID+EQ+(${ProjectId})`;
  dispatch(setRedirectUrl(redirectUrl));

  // Navigate to project management
  navigate("/projectmanagement");
};
